var RelationshipType;
(function (RelationshipType) {
    RelationshipType[RelationshipType["SELF"] = 0] = "SELF";
    RelationshipType[RelationshipType["PARENT"] = 1] = "PARENT";
    RelationshipType[RelationshipType["CHILD"] = 2] = "CHILD";
    RelationshipType[RelationshipType["SIBLING"] = 3] = "SIBLING";
    RelationshipType[RelationshipType["SPOUSE"] = 4] = "SPOUSE";
})(RelationshipType || (RelationshipType = {}));
export default RelationshipType;
